import { useState } from "react";

const Row = ({ label, value, bold = false }) => (
  <div
    className={`flex justify-between border-b py-1 text-sm ${
      bold ? "font-bold" : ""
    }`}
  >
    <span className="text-gray-700">{label}</span>
    <span className="text-gray-900">{value}</span>
  </div>
);

const SubsidyAmountsRemarks = ({ data }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="space-y-2 text-sm">
      <p className="font-semibold">Application is Submitted</p>
      <p className="font-semibold">Data submiited by user:</p>

      {!expanded ? (
        <>
          <div className="ml-2 border rounded bg-gray-50 p-2 space-y-1">
            <Row label="Total Investment" value={data.total_investment} bold />
            <Row
              label="Total Non-Eligible"
              value={data.total_non_eligible}
              bold
            />
            <Row
              label="Total Max Subsidy"
              value={data.total_max_capital_subsidy}
              bold
            />
          </div>

          <span
            className="text-theme-color underline text-xs cursor-pointer"
            onClick={() => setExpanded(true)}
          >
            View full details
          </span>
        </>
      ) : (
        <>
          {/* Capital Investment */}
          <div>
            <p className="font-bold mb-1">Capital Investment</p>
            <div className="ml-3 border rounded bg-gray-50 p-2 space-y-1">
              <Row
                label="Land (if admissible)"
                value={data.land_if_admissible}
              />
              <Row
                label="Building & Civil Works"
                value={data.building_civil_works}
              />
              <Row label="Plant & Machinery" value={data.plant_machinery} />
              <Row
                label="Furniture & Fixtures"
                value={data.furniture_fixtures}
              />
              <Row
                label="Utilities & Infrastructure"
                value={data.utilities_infrastructure}
              />
              <Row label="Other Expenses" value={data.other_expenses} />
              <Row
                label="Total Investment"
                value={data.total_investment}
                bold
              />
            </div>
          </div>

          {/* Non Eligible Investment */}
          <div>
            <p className="font-bold mb-1">Non Eligible Investment</p>
            <div className="ml-3 border rounded bg-gray-50 p-2 space-y-1">
              <Row
                label="Expenses Prior in Principal"
                value={data.expenses_prior_in_principal}
              />
              <Row
                label="No Bills After in Principal"
                value={data.expenses_no_bills_after_in_principal}
              />
              <Row
                label="Paid in Cash/Other"
                value={data.expenses_paid_cash_other}
              />
              <Row
                label="Cost of Land & Stamp Duty"
                value={data.cost_land_stamp_duty}
              />
              <Row
                label="Consultancy & Other Taxes"
                value={data.cost_consultancy_other_taxes}
              />
              <Row
                label="Site Development & Valuation"
                value={data.site_development_valuation}
              />
              <Row
                label="Total Non-Eligible"
                value={data.total_non_eligible}
                bold
              />
            </div>
          </div>

          {/* Eligible Investment */}
          <div>
            <p className="font-bold mb-1">Eligible Investment</p>
            <div className="ml-3 border rounded bg-gray-50 p-2">
              <Row
                label="Total Eligible Investment"
                value={
                  data.total_eligible_investment_after_non_eligible_deduction
                }
                bold
              />
            </div>
          </div>

          {/* Tentative Capital Subsidy */}
          <div>
            <p className="font-bold mb-1">Tentative Capital Subsidy</p>
            <div className="ml-3 border rounded bg-gray-50 p-2 space-y-1">
              <Row
                label="Minimum Investment"
                value={data.capital_subsidy_min_investment}
              />
              <Row
                label="Additional Investment"
                value={data.capital_subsidy_additional_investment}
              />
              <Row
                label="Total Max Subsidy"
                value={data.total_max_capital_subsidy}
                bold
              />
            </div>
          </div>

          <span
            className="text-theme-color underline text-xs cursor-pointer"
            onClick={() => setExpanded(false)}
          >
            Hide details
          </span>
        </>
      )}
    </div>
  );
};

export default SubsidyAmountsRemarks;
